import { Component } from "@angular/core";

@Component({
    selector:'app-ContractDetail-table',
    imports:[],
    templateUrl:'./contract-detail-table.html',
    styleUrl:'./contract-detail-table.css'
})
export class ContractDetailTable{

    
}